import styled from 'styled-components';

export const StyledLogoutModal = styled.div``;
